import { Placement } from 'react-aria';
import {
  Header as AriaHeader,
  Key,
  Menu as AriaMenu,
  MenuItem as AriaMenuItem,
  MenuSection,
  MenuTrigger,
  Popover,
  Separator as AriaSeparator,
} from 'react-aria-components';

import { createBEMClasses } from '@/utils/classname';

import './Menu.css';

const { block, element } = createBEMClasses('menu');

const Menu = ({
  trigger,
  onAction,
  children,
  placement,
}: {
  trigger: React.ReactNode;
  onAction?: (id: string) => void;
  children: React.ReactNode;
  placement?: Placement;
}) => {
  return (
    <MenuTrigger>
      {trigger}
      <Popover placement={placement}>
        <AriaMenu className={block()} onAction={(key: Key) => onAction?.(key as string)}>
          {children}
        </AriaMenu>
      </Popover>
    </MenuTrigger>
  );
};

export default Menu;

export const MenuItem = ({
  id,
  children,
  size = 'medium',
  href,
  download,
}: {
  id: string;
  children: React.ReactNode;
  size?: 'medium' | 'large';
  href?: string;
  download?: boolean | string;
}) => {
  return (
    <AriaMenuItem
      id={id}
      className={element('item', { size })}
      href={href}
      download={download}
      target={download ? '_blank' : undefined}
    >
      {children}
    </AriaMenuItem>
  );
};

export const DangerMenuItem = ({
  id,
  children,
  size = 'medium',
}: {
  id: string;
  children: React.ReactNode;
  size?: 'medium' | 'large';
}) => {
  return (
    <AriaMenuItem id={id} className={element('item', { danger: true, size })}>
      {children}
    </AriaMenuItem>
  );
};

export const Section = ({ children }: { children: React.ReactNode }) => {
  return <MenuSection className={element('section')}>{children}</MenuSection>;
};

export const Header = ({ children }: { children: React.ReactNode }) => {
  return <AriaHeader className={element('header')}>{children}</AriaHeader>;
};

export const Separator = () => {
  return <AriaSeparator className={element('separator')} />;
};
